import { getUserCompanyList } from '@/common/js/util';
export const searchFormColumns = (ctx) => {
  return [
    {
      name: '公司',
      prop: 'workOrderCompanyNo',
      type: 'select',
      options: getUserCompanyList(),
      changeMethod: 'changeMethod',
    },
    { name: '工单编号', prop: 'workOrderNo', type: 'input', placeholder: '请输入' },
    { name: '工单名称', prop: 'name', type: 'input', placeholder: '请输入' },
    {
      name: '工单类型',
      prop: 'type',
      type: 'select',
      options: ctx.setOptions.workOrderType || [],
      currentValue: ctx.type,
    },
    {
      name: '工单状态',
      prop: 'workOrderStatus',
      type: 'select',
      options: ctx.setOptions.workOrderStatus || [],
    },
    { name: '报修单号', prop: 'repairNo', type: 'input', placeholder: '请输入' },
    {
      name: '派单部门',
      prop: 'workOrderDepartmentNo',
      type: 'select',
      options: ctx.departmentList || [],
      disabled: !ctx.query.workOrderCompanyNo,
    },
    { name: '派单人', prop: 'dispatchPersonName', type: 'input', placeholder: '请输入' },
    { name: '派单时间开始', prop: 'dispatchDateStart', type: 'startDaterangePicker' },
    { name: '派单时间结束', prop: 'dispatchDateEnd', type: 'endDaterangePicker' },
  ];
};
export const columnListDefault = [
  {
    field: 'workOrderNo',
    title: '工单编号',
    visible: true,
  },
  {
    field: 'workOrderCompanyName',
    title: '公司',
    visible: true,
  },
  {
    field: 'name',
    title: '工单名称',
    visible: true,
  },
  {
    field: 'typeStr',
    title: '工单类型',
    visible: true,
  },
  {
    field: 'repairNo',
    title: '报修单号',
    visible: true,
  },
  {
    field: 'workOrderDepartmentName',
    title: '派单部门',
    visible: true,
  },
  {
    field: 'dispatchPersonName',
    title: '派单人',
    visible: true,
  },
  {
    field: 'receivePersonName',
    title: '接单人',
    visible: true,
  },
  {
    field: 'workOrderStatusStr',
    title: '工单状态',
    visible: true,
  },
  {
    field: 'dispatchTime',
    title: '派单时间',
    visible: true,
  },
];
